import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Catalog } from '../models/catalog.entity'

export type CatalogNotificationCode =
  | GenericNotificationCode
  | 'CATALOG_DELETED'
  | 'CATALOG_NOT_FOUND'
  | 'CATALOG_SAVED'
  | 'MISSING_DEFAULT_LANGUAGE'

export type CatalogModalCode = 'CATALOG_DELETION'

/**
 * Parse catalog code to a notification
 * @param code - the catalog notification code
 * @returns the notification options
 */
export function parseCatalogNotification(
  code?: CatalogNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'CATALOG_DELETED':
      return {
        message: 'Catalog deleted successfully',
        color: 'success',
      }
    case 'CATALOG_NOT_FOUND':
      return { message: 'Catalog not found', color: 'error' }
    case 'CATALOG_SAVED':
      return {
        message: 'Catalog saved successfully',
        color: 'success',
      }
    case 'MISSING_DEFAULT_LANGUAGE':
      return {
        message: 'The default catalog shoud have the default language',
        color: 'error',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse catalog code to an modal
 * @param code - the catalog modal code
 * @param catalog - the catalog object
 * @returns the modal settings
 */
export function parseCatalogModal(
  code: CatalogModalCode,
  catalog?: Catalog,
): DialogOptions {
  switch (code) {
    case 'CATALOG_DELETION': {
      const ctName = catalog?.name.default
      return {
        title: 'Delete catalog',
        message:
          'You are about to delete the catalog <strong>%s</strong>. Proceed with deletion?',
        messageParams: ctName ? [ctName] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
